import type { ReactNode } from 'react';
export function EmptyState({
  icon,
  title,
  sub,
  action,
}: {
  icon?: ReactNode;
  title: ReactNode;
  sub?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 gap-2">
      {icon && <div className="text-ink-4 mb-2">{icon}</div>}
      <div className="text-h3 font-bold text-ink-2">{title}</div>
      {sub && <div className="text-body text-ink-3">{sub}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
